module.exports = __webpack_public_path__ + "img/pickup.650e7e23.svg";